/** Paperwork pages in the new design: App.tsx route path -> component. Empty = the classic page shows. */
import type { ComponentType } from "react";

export const paperworkPages: Record<string, ComponentType> = {};
